import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { timelineBackgrounds } from "../data/timeline";
import { tempTimelineData } from "features/timeline/data/temp-timeline-data";
import { useHttpClient } from 'hooks/http-hook';
import { useAuth } from "providers/AuthProvider";

const TimelineContext = createContext();

const randomizeBackground = () => {
  const randomIndex = Math.floor(Math.random() * timelineBackgrounds.length);
  return timelineBackgrounds[randomIndex];
};

const defaultTimelineSettings = {
  containToMyLife: true,
  showAllDays: false,
  theme: randomizeBackground(),
};

export const TimelineProvider = ({ children }) => {
  const { token } = useAuth();
  const { sendRequest } = useHttpClient();
  const [isLoading, setIsLoading] = useState(false);
  const [allEvents, setAllEvents] = useState([]);
  const [myLifetimeEvents, setMyLifetimeEvents] = useState([]);
  const [timelineEvents, setTimelineEvents] = useState([]);
  const [timelineSettings, setTimelineSettings] = useState(defaultTimelineSettings);
  const [timelineSettingsModalIsOpen, setTimelineSettingsModalIsOpen] = useState(false);

  const sortEvents = (events) => {
    const chronologicalByFromDate = [...events].sort( (a, b) => new Date(a.fromDate) - new Date(b.fromDate) );
    return chronologicalByFromDate;
  }

  const getDateFromYearAsNumber = (dateFrom) => {
    return Number(dateFrom.slice(0, 4));
  }

  const filterEventsRange = (events, startYear) => {
    return events.filter(x => getDateFromYearAsNumber(x.dateFrom) >= startYear);
  }

  const fetchDays = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/`, 'GET', null, {Authorization: 'Bearer ' + token});
      const loadedDays = response.days;      
      const timelineDays = loadedDays.filter(x => x.addToTimeline);
      const allEvents = sortEvents(timelineDays);
      // setAllEvents(allEvents);
      // const myLifetimeEvents = filterEventsRange(allEvents, 1981);
      // setMyLifetimeEvents(myLifetimeEvents);
      // setTimelineEvents(timelineSettings.containToMyLife ? myLifetimeEvents : allEvents);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  }, [sendRequest, token]);

  useEffect(() => {
    // TODO: Fetch Events
    fetchDays(); // TEMP: fetching days to simulate fetching timeline events or however you're going to do this

    const allEvents = sortEvents(tempTimelineData);
    setAllEvents(allEvents);

    const myLifetimeEvents = filterEventsRange(allEvents, 1981);
    setMyLifetimeEvents(myLifetimeEvents);

    setTimelineEvents(timelineSettings.containToMyLife ? myLifetimeEvents : allEvents);
  }, []);

  const updateTimelineSettings = (newSettings) => {
    setTimelineEvents(newSettings.containToMyLife ? myLifetimeEvents : allEvents);
    setTimelineSettings(prev => ({ ...prev, ...newSettings }));
    setTimelineSettingsModalIsOpen(false);
  };

  const resetTimelineSettings = () => {
    setTimelineSettings(defaultTimelineSettings);
    setTimelineSettingsModalIsOpen(false);
  };

  return (
    <TimelineContext.Provider value={{
      isLoading,
      timelineEvents,
      timelineSettings,
      updateTimelineSettings,
      resetTimelineSettings,
      timelineSettingsModalIsOpen,
      setTimelineSettingsModalIsOpen,
      getDateFromYearAsNumber,
    }}>
      {children}
    </TimelineContext.Provider>
  );
};

export const useTimelineContext = () => useContext(TimelineContext);
